import React from 'react';
import { PropTypes } from 'prop-types';

// Components
import Search from '../../searches/Search';
import SearchResults from '../../searches/Search/SearchResults';
import CompanyListItemRedesign from '@cards/CompanyListItemRedesign';
import { DivWithShadowAlternate, H4 } from '@styled';

// Functionality
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';
import useCompaniesSimilarToFilterString from './hooks/useCompaniesSimilarToFilterString';
import { GET_COMPANIES_FOR_SEARCH } from '@general/graphql/company.graph';
import { mapSearchCompanyToProps } from '@general/transforms/company.transform';
import useCompanyFull from '@hooks/useCompanyFull';

const CompanyProfileCompaniesSimilarTo = ({ graphID }) => {
    const { data: companyData } = useCompanyFull(graphID);
    const { filterString } = useCompaniesSimilarToFilterString({ company: companyData });

    if (!companyData || !filterString) return null;

    const algoliaIndex = 'companies_recently_joined_virtual';

    return (
        <div className="col-lg-12 mt-4">
            <H4 className="mb-1.5rem">Companies Similar to {companyData?.name}</H4>
            <DivWithShadowAlternate className="p-4" style={{ width: '100%' }}>
                <SearchModeContext.Provider value={{ showFilters: false }}>
                    <Search
                        filters={filterString}
                        index={algoliaIndex}
                        defaultViewType="card"
                        displaySearchBox={false}
                        displaySearchOptions={false}
                        displayPagingToolbar={false}
                        hitsPerPage={4}
                        maxWidth="auto"
                    >
                        <SearchResults
                            listItemComponent={CompanyListItemRedesign}
                            cardComponent={CompanyListItemRedesign}
                            query={GET_COMPANIES_FOR_SEARCH}
                            resultsPerRow={2}
                            transformFunc={mapSearchCompanyToProps}
                            typePlural="companies"
                            index={algoliaIndex}
                        />
                    </Search>
                </SearchModeContext.Provider>
            </DivWithShadowAlternate>
        </div>
    );
};

CompanyProfileCompaniesSimilarTo.propTypes = {
    graphID: PropTypes.string,
};

export default CompanyProfileCompaniesSimilarTo;
